/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "учора",
        "-2": "пазаўчора",
        "0": "сёння",
        "1": "заўтра",
        "2": "паслязаўтра",
        "future": {
          "few": "праз {0} дні",
          "many": "праз {0} дзён",
          "one": "праз {0} дзень",
          "other": "праз {0} дня"
        },
        "past": {
          "few": "{0} дні таму",
          "many": "{0} дзён таму",
          "one": "{0} дзень таму",
          "other": "{0} дня таму"
        }
      },
      "day-narrow": {
        "-1": "учора",
        "-2": "пазаўчора",
        "0": "сёньня",
        "1": "заўтра",
        "2": "паслязаўтра",
        "future": {
          "few": "праз {0} дні",
          "many": "праз {0} дзён",
          "one": "праз {0} дзень",
          "other": "праз {0} дня"
        },
        "past": {
          "few": "{0} дні таму",
          "many": "{0} дзён таму",
          "one": "{0} дзень таму",
          "other": "{0} дня таму"
        }
      },
      "day-short": {
        "-1": "учора",
        "-2": "пазаўчора",
        "0": "сёньня",
        "1": "заўтра",
        "2": "паслязаўтра",
        "future": {
          "few": "праз {0} дні",
          "many": "праз {0} дзён",
          "one": "праз {0} дзень",
          "other": "праз {0} дня"
        },
        "past": {
          "few": "{0} дні таму",
          "many": "{0} дзён таму",
          "one": "{0} дзень таму",
          "other": "{0} дня таму"
        }
      },
      "hour": {
        "0": "у гэту гадзіну",
        "future": {
          "few": "праз {0} гадзіны",
          "many": "праз {0} гадзін",
          "one": "праз {0} гадзіну",
          "other": "праз {0} гадзіны"
        },
        "past": {
          "few": "{0} гадзіны таму",
          "many": "{0} гадзін таму",
          "one": "{0} гадзіну таму",
          "other": "{0} гадзіны таму"
        }
      },
      "hour-narrow": {
        "0": "у гэтую гадзіну",
        "future": {
          "few": "праз {0} гадз",
          "many": "праз {0} гадз",
          "one": "праз {0} гадз",
          "other": "праз {0} гадз"
        },
        "past": {
          "few": "{0} гадз таму",
          "many": "{0} гадз таму",
          "one": "{0} гадз таму",
          "other": "{0} гадз таму"
        }
      },
      "hour-short": {
        "0": "у гэтую гадзіну",
        "future": {
          "few": "праз {0} гадз",
          "many": "праз {0} гадз",
          "one": "праз {0} гадз",
          "other": "праз {0} гадз"
        },
        "past": {
          "few": "{0} гадз таму",
          "many": "{0} гадз таму",
          "one": "{0} гадз таму",
          "other": "{0} гадз таму"
        }
      },
      "minute": {
        "0": "у гэту хвіліну",
        "future": {
          "few": "праз {0} хвіліны",
          "many": "праз {0} хвілін",
          "one": "праз {0} хвіліну",
          "other": "праз {0} хвіліны"
        },
        "past": {
          "few": "{0} хвіліны таму",
          "many": "{0} хвілін таму",
          "one": "{0} хвіліну таму",
          "other": "{0} хвіліны таму"
        }
      },
      "minute-narrow": {
        "0": "у гэтую хвіліну",
        "future": {
          "few": "праз {0} хв",
          "many": "праз {0} хв",
          "one": "праз {0} хв",
          "other": "праз {0} хв"
        },
        "past": {
          "few": "{0} хв таму",
          "many": "{0} хв таму",
          "one": "{0} хв таму",
          "other": "{0} хв таму"
        }
      },
      "minute-short": {
        "0": "у гэтую хвіліну",
        "future": {
          "few": "праз {0} хв",
          "many": "праз {0} хв",
          "one": "праз {0} хв",
          "other": "праз {0} хв"
        },
        "past": {
          "few": "{0} хв таму",
          "many": "{0} хв таму",
          "one": "{0} хв таму",
          "other": "{0} хв таму"
        }
      },
      "month": {
        "-1": "у мінулым месяцы",
        "0": "у гэтым месяцы",
        "1": "у наступным месяцы",
        "future": {
          "few": "праз {0} месяцы",
          "many": "праз {0} месяцаў",
          "one": "праз {0} месяц",
          "other": "праз {0} месяца"
        },
        "past": {
          "few": "{0} месяцы таму",
          "many": "{0} месяцаў таму",
          "one": "{0} месяц таму",
          "other": "{0} месяца таму"
        }
      },
      "month-narrow": {
        "-1": "у мін. мес.",
        "0": "у гэтым мес.",
        "1": "у наст. мес.",
        "future": {
          "few": "праз {0} мес.",
          "many": "праз {0} мес.",
          "one": "праз {0} мес.",
          "other": "праз {0} мес."
        },
        "past": {
          "few": "{0} мес. таму",
          "many": "{0} мес. таму",
          "one": "{0} мес. таму",
          "other": "{0} мес. таму"
        }
      },
      "month-short": {
        "-1": "у мін. мес.",
        "0": "у гэтым мес.",
        "1": "у наст. мес.",
        "future": {
          "few": "праз {0} мес.",
          "many": "праз {0} мес.",
          "one": "праз {0} мес.",
          "other": "праз {0} мес."
        },
        "past": {
          "few": "{0} мес. таму",
          "many": "{0} мес. таму",
          "one": "{0} мес. таму",
          "other": "{0} мес. таму"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "у мінулым квартале",
        "0": "у гэтым квартале",
        "1": "у наступным квартале",
        "future": {
          "few": "праз {0} кварталы",
          "many": "праз {0} кварталаў",
          "one": "праз {0} квартал",
          "other": "праз {0} квартала"
        },
        "past": {
          "few": "{0} кварталы таму",
          "many": "{0} кварталаў таму",
          "one": "{0} квартал таму",
          "other": "{0} квартала таму"
        }
      },
      "quarter-narrow": {
        "-1": "у мінулым квартале",
        "0": "у гэтым квартале",
        "1": "у наступным квартале",
        "future": {
          "few": "праз {0} кв.",
          "many": "праз {0} кв.",
          "one": "праз {0} кв.",
          "other": "праз {0} кв."
        },
        "past": {
          "few": "{0} кв. таму",
          "many": "{0} кв. таму",
          "one": "{0} кв. таму",
          "other": "{0} кв. таму"
        }
      },
      "quarter-short": {
        "-1": "у мінулым квартале",
        "0": "у гэтым квартале",
        "1": "у наступным квартале",
        "future": {
          "few": "праз {0} кв.",
          "many": "праз {0} кв.",
          "one": "праз {0} кв.",
          "other": "праз {0} кв."
        },
        "past": {
          "few": "{0} кв. таму",
          "many": "{0} кв. таму",
          "one": "{0} кв. таму",
          "other": "{0} кв. таму"
        }
      },
      "second": {
        "0": "цяпер",
        "future": {
          "few": "праз {0} секунды",
          "many": "праз {0} секунд",
          "one": "праз {0} секунду",
          "other": "праз {0} секунды"
        },
        "past": {
          "few": "{0} секунды таму",
          "many": "{0} секунд таму",
          "one": "{0} секунду таму",
          "other": "{0} секунды таму"
        }
      },
      "second-narrow": {
        "0": "цяпер",
        "future": {
          "few": "праз {0} с",
          "many": "праз {0} с",
          "one": "праз {0} с",
          "other": "праз {0} с"
        },
        "past": {
          "few": "{0} с таму",
          "many": "{0} с таму",
          "one": "{0} с таму",
          "other": "{0} с таму"
        }
      },
      "second-short": {
        "0": "цяпер",
        "future": {
          "few": "праз {0} с",
          "many": "праз {0} с",
          "one": "праз {0} с",
          "other": "праз {0} с"
        },
        "past": {
          "few": "{0} с таму",
          "many": "{0} с таму",
          "one": "{0} с таму",
          "other": "{0} с таму"
        }
      },
      "week": {
        "-1": "на мінулым тыдні",
        "0": "на гэтым тыдні",
        "1": "на наступным тыдні",
        "future": {
          "few": "праз {0} тыдні",
          "many": "праз {0} тыдняў",
          "one": "праз {0} тыдзень",
          "other": "праз {0} тыдня"
        },
        "past": {
          "few": "{0} тыдні таму",
          "many": "{0} тыдняў таму",
          "one": "{0} тыдзень таму",
          "other": "{0} тыдня таму"
        }
      },
      "week-narrow": {
        "-1": "на мін. тыд.",
        "0": "на гэтым тыд.",
        "1": "на наст. тыд.",
        "future": {
          "few": "праз {0} тыд",
          "many": "праз {0} тыд",
          "one": "праз {0} тыд",
          "other": "праз {0} тыд"
        },
        "past": {
          "few": "{0} тыд таму",
          "many": "{0} тыд таму",
          "one": "{0} тыд таму",
          "other": "{0} тыд таму"
        }
      },
      "week-short": {
        "-1": "на мін. тыд.",
        "0": "на гэтым тыд.",
        "1": "на наст. тыд.",
        "future": {
          "few": "праз {0} тыд",
          "many": "праз {0} тыд",
          "one": "праз {0} тыд",
          "other": "праз {0} тыд"
        },
        "past": {
          "few": "{0} тыд таму",
          "many": "{0} тыд таму",
          "one": "{0} тыд таму",
          "other": "{0} тыд таму"
        }
      },
      "year": {
        "-1": "у мінулым годзе",
        "0": "у гэтым годзе",
        "1": "у наступным годзе",
        "future": {
          "few": "праз {0} гады",
          "many": "праз {0} гадоў",
          "one": "праз {0} год",
          "other": "праз {0} года"
        },
        "past": {
          "few": "{0} гады таму",
          "many": "{0} гадоў таму",
          "one": "{0} год таму",
          "other": "{0} года таму"
        }
      },
      "year-narrow": {
        "-1": "у мін. годзе",
        "0": "у гэтым годзе",
        "1": "у наст. годзе",
        "future": {
          "few": "праз {0} г.",
          "many": "праз {0} г.",
          "one": "праз {0} г.",
          "other": "праз {0} г."
        },
        "past": {
          "few": "{0} г. таму",
          "many": "{0} г. таму",
          "one": "{0} г. таму",
          "other": "{0} г. таму"
        }
      },
      "year-short": {
        "-1": "у мін. годзе",
        "0": "у гэтым годзе",
        "1": "у наст. годзе",
        "future": {
          "few": "праз {0} г.",
          "many": "праз {0} г.",
          "one": "праз {0} г.",
          "other": "праз {0} г."
        },
        "past": {
          "few": "{0} г. таму",
          "many": "{0} г. таму",
          "one": "{0} г. таму",
          "other": "{0} г. таму"
        }
      }
    },
    "locale": "be-tarask"
  });
}